export function ReportScheduleSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/report-schedule.svg'"></ng-include>`
    }
}

